module.exports = __webpack_public_path__ + "img/sale1.8480b662.png";